import { useState } from 'react'
import AXButton from '@/components/AXButton'
import LoadDataContainer from '@/components/LoadDataContainer'
import { Mask } from 'antd-mobile'
import LogoAixue from '@/assets/img/aixue-logo.png'
import { isIOS, isWeChat } from '@/utils/ua'
import { useAppDownloadConfigStore } from '@/store/useAppDownloadConfig'
import ImageTipArrow from '@/assets/img/download-tips-arrow.png'
import { useTitle } from 'ahooks'
import { appScheme } from '@/config';
import useParams from '@/hooks/useParams';


const DownloadApp = () => {
  const { queryParams } = useParams();
  const { appDownloadConfig, appPkgUrl, getAppDownloadConfig, getAppPkgUrl } = useAppDownloadConfigStore();
  const [maskVisible, setMaskVisible] = useState(false);
  useTitle('爱学AI学')

  const download = () => {
    if(isWeChat()) {
      setMaskVisible(true);
      return;
    }
    let downloadUrl = '';
    if (isIOS()) {
      downloadUrl = appDownloadConfig?.ios_url || '';
    } else {
      downloadUrl = appPkgUrl || appDownloadConfig?.android_url || '';
    }
    if (downloadUrl) {
      window.location.href = downloadUrl;
    }
  }

  const openApp = () => {
    if (isWeChat()) {
      download();
      return;
    }
    window.open(appScheme, '_self');
  }

  const onFetch = async () => {
    await Promise.all([getAppDownloadConfig(), getAppPkgUrl(queryParams)]);
  }

  return (
    <LoadDataContainer onFetch={onFetch}>
      <div className="flex flex-col items-center w-screen h-screen px-32px bg-[#FFFFFF]">
        <section className="flex flex-col items-center justify-center mt-140px mb-96px">
          <img className="w-[88px] h-[88px]" src={LogoAixue} alt="aixue-app" />
          <p className="text-24px color-[#08021E] font-semibold mt-24px">AI学就爱学</p>
          <p className="text-18px color-[#373D48] font-semibold mt-8px">你的专属AI一对一导师</p>
        </section>
        <section className="w-full flex flex-col items-center justify-center">
          <AXButton
            className="w-full mb-16px"
            type="primary"
            block
            onClick={download}
          >立即下载</AXButton>
          <AXButton
            className="w-full !border-color-[#3370FF] !text-[#3370FF] !font-normal"
            type="default"
            block
            onClick={openApp}
          >已下载，打开 APP</AXButton>
        </section>
      </div>
      <Mask visible={maskVisible} onMaskClick={() => setMaskVisible(false)}>
        <div className="flex flex-col items-end mr-[16px]">
          <img className="w-[90px] h-[75px]" src={ImageTipArrow} alt="tips-arrow" />
          <div className="h-[42px] bg-[#FFF6F2] rounded-12px p-12px text-16px line-height-[16px] color-[#2E2E2E]">
            点击右上角<span className="text-[#3370FF]">选择浏览器</span>打开哦~
          </div>
        </div>
      </Mask>
    </LoadDataContainer>
  )
}

export default DownloadApp